import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appCharacterGrouper'
})
export class CharacterGrouperPipe implements PipeTransform {
  transform(text: string, groupCount = 3) : string {
    return characterGrouperFn(text, groupCount);
  }
}

function characterGrouperFn(text, groupCount = 3) {
  if (!text) {
    return '';
  }

  return text.match(new RegExp(`.{1,${groupCount}}`, 'g')).join(' ');
}
